import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import React from 'react'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'

class AddMappingForm extends React.Component {
    state = {
        selectedRoom: 0,
        selectedCategory: 0
    }

    handleChangeCategory = e => {
        this.setState({
            selectedRoom: 0,
            selectedCategory: e.target.value
        })
    }

    handleChangeRoom = e => {
        this.setState({
            selectedRoom: e.target.value
        })
    }

    handleClose = () => {
        this.setState({
            selectedCategory: 0,
            selectedRoom: 0
        })
        this.props.handleClose()
    }

    handleSave = data => {
        this.setState({
            selectedCategory: 0,
            selectedRoom: 0
        })
        this.props.handleSave(data)
        this.props.handleClose()
    }

    render() {
        const { selectedRoom, selectedCategory } = this.state
        const { open, easymsCategories, listOfRoomsWithCategories } = this.props
        const isdisabled = open.type === 'private' ? !selectedRoom : false

        return (
            <Dialog open={!!open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{`Создание маппинга для ${
                    open.type === 'private' ? 'приватной' : 'общедоступной'
                } комнаты`}</DialogTitle>
                {open.type === 'private' && (
                    <DialogContent>
                        <InputLabel htmlFor="organization-simple">Выберите категорию</InputLabel>
                        <Select style={{ width: '100%' }} value={selectedCategory} onChange={this.handleChangeCategory}>
                            {easymsCategories.map(org => (
                                <MenuItem key={org.id} value={org.id}>
                                    {org.name}
                                </MenuItem>
                            ))}
                        </Select>
                        {!!selectedCategory && (
                            <React.Fragment>
                                <InputLabel htmlFor="organization-simple">Выберите комнату</InputLabel>
                                <Select style={{ width: '100%' }} value={selectedRoom} onChange={this.handleChangeRoom}>
                                    {listOfRoomsWithCategories
                                        .filter(item => item.category === selectedCategory)
                                        .map(room => (
                                            <MenuItem key={room.id} value={room.id}>
                                                {room.name}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </React.Fragment>
                        )}
                    </DialogContent>
                )}
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        Отмена
                    </Button>
                    <Button
                        disabled={isdisabled}
                        onClick={() =>
                            this.handleSave({
                                remoteId: open.remoteId,
                                type: open.type,
                                roomId: selectedRoom
                            })
                        }
                        color="primary"
                    >
                        Сохранить
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default AddMappingForm



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/MappingTabs/LockTab/LockTabTable/AddMappingForm.js